import { useState, useEffect } from 'react';
import { WifiOff, X } from 'lucide-react';

export function OfflineBanner() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setDismissed(false);
    };
    const handleOffline = () => {
      setIsOnline(false);
      setDismissed(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-16 lg:bottom-0 inset-x-0 z-30
                    bg-orange-500 text-white px-4 py-2
                    flex items-center justify-center gap-3 text-sm">
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <span>
        Keine Internetverbindung. Änderungen werden lokal gespeichert und bei Wiederverbindung synchronisiert.
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 hover:bg-orange-600 rounded transition-colors flex-shrink-0"
        aria-label="Schließen"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
